<form
  #ngForm="ngForm"
  id="questionnaire"
  [formGroup]="form"
  (ngSubmit)="submit(ngForm)"
  novalidate
>
  <p
    *ngIf="state === 'form' && !isSingleResult"
    class="p5-semibold text-muted gpt-sm-24 gmb-8"
  >
    {{ questionnaireIndex() + 1 }} / {{ questionnaires?.length }}
  </p>

  <ng-template questionnaireHost></ng-template>

  <app-questionnaire-date
    *ngIf="isSingleResult && state === 'form'"
    [formFieldAppearance]="formFieldAppearance"
    [questionnaireId]="questionnaires[questionnaireIndex()]?.id"
  />

  <ng-container
    *ngTemplateOutlet="
      { loading: loadingTemplate, error: errorTemplate, form: buttonsTemplate }[
        state
      ]
    "
  ></ng-container>
</form>

<ng-template #buttonsTemplate>
  <div class="gmb-96 gmb-md-56"></div>

  <app-form-page-footer
    class="gmt-96 gmt-md-56"
    [class.bg-white]="formFieldAppearance === GpuFormFieldAppearance.Outline"
    [class.gmt-144]="!isSingleResult"
  >
    <div class="d-sm-inline-flex d-flex gmb-sm-16 flex-row">
      <button
        *ngIf="questionnaireIndex() > 0"
        type="button"
        class="text-primary bg-transparent gp-12 border-0 gmr-24 gmr-sm-12"
        gptDataTrack="questionnaire-previous"
        (click)="previous()"
      >
        <i class="gpicon-back-fat"></i>
      </button>

      <button
        type="submit"
        class="gbtn-1 gbtn-sq gbtn-spinner b2-semibold w-100"
        [disabled]="form.invalid"
        [gptDataTrack]="
          isSingleResult ? 'analyses-add-submit' : 'analyses-add-next'
        "
      >
        {{
          (isSingleResult ? 'ANALYSES.ADD_RESULT' : 'ANALYSES.NEXT') | translate
        }}
      </button>
    </div>
  </app-form-page-footer>
</ng-template>

<ng-template #errorTemplate>
  <div class="gp-alert gp-alert-danger p3-regular mb-4">
    <span class="p3-semibold">{{ 'ERROR' | translate }}</span>
    {{ 'FAILURE.GENERAL_ERROR.CONTENT' | translate }}
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <gpu-loading-spinner-wrapper>
    <gpu-loading-spinner></gpu-loading-spinner>
  </gpu-loading-spinner-wrapper>
</ng-template>
